import type { ComponentType } from 'react';

import type { IconProps } from '../../icons';
import {
  AssignmentTurnedInIcon,
  BusinessIcon,
  CalendarIcon,
  CommunicationIcon,
  DocumentIcon,
  OtherResourceIcon,
  PendingActionsIcon,
  ReminderIcon,
  WarningIcon,
} from '../../icons';
import type { ResourceColorName } from './resourcesColors';

export type ResourceIcons = Record<ResourceColorName, ComponentType<IconProps>>;

export const resourcesIcons: ResourceIcons = {
  documents: DocumentIcon,
  communications: CommunicationIcon,
  rendezVous: CalendarIcon,
  'rendez-vous': CalendarIcon,
  incident: WarningIcon,
  rappel: ReminderIcon,
  autre: OtherResourceIcon,
  providers: BusinessIcon,
  task: AssignmentTurnedInIcon,
  pending_item: PendingActionsIcon,
};
